import { createContext } from "react";
import { View } from "views/View";

export interface AgendaItemViewsContextProps {
  views: View[];
  selectedView: View;
  setSelectedViewName: (name: string) => void;
}

export const AgendaItemViewsContext = createContext({} as AgendaItemViewsContextProps);
